var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.keywords)?_c('div',[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"tags"}}),_vm._v(" "),_vm._l((_vm.keywords),function(keyword){return _c('span',{key:keyword,on:{"click":function($event){_vm.type === 'organisation' ? _vm.searchOrganisation(keyword)
        : _vm.type === 'recipe' ? _vm.searchRecipes(keyword)
        : _vm.type === 'ingredient' ? _vm.searchIngredients(keyword) : null}}},[_c('b-badge',{staticClass:"mr-2 bg-orange",attrs:{"pill":""}},[_vm._v(_vm._s(keyword))])],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27609abb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Keywords.vue
// module id = null
// module chunks = 